import React from 'react';
import { TColumn } from 'components/tables/Table/types';
import { apiPsusRead } from 'services/dataFetching/crud';
import moment from 'moment';
import clsx from 'clsx';

export const columns: Array<TColumn> = [
  { Header: 'Email', accessor: 'email' },
  {
    Header: 'Full name',
    Cell: ({ row }) => {
      return (
        <>
          {row.firstName} {row.lastName}
        </>
      );
    },
  },
  { Header: 'Phone', accessor: 'phone' },
  {
    Header: 'Created at',
    accessor: 'created_at',
    Cell: ({ value }) => {
      return <>{moment(value).format('YYYY/MM/DD HH:mm')}</>;
    },
  },
  {
    Header: 'Status',
    accessor: 'deleted_at',
    tdClassName: '-deletedAt',
    Cell: ({ value }) => {
      const isDeleted =
        moment(value).valueOf() > 0
          ? moment(value).format('DD/MM/YYYY HH:mm')
          : false;

      return (
        <div
          className={clsx('isDeleted', (isDeleted && '--deleted') || '--ok')}
        >
          {isDeleted ? '✖' : `✔`}
        </div>
      );
    },
  },
];

export const tableApiCall = (dispatch?: any) => ({
  apiCall: (body: any) =>
    apiPsusRead(body).then((r: any) => ({
      data: r.body.psus,
      total: r.body.total,
    })),
});
